import type { CartConfig } from '#types/config/pages/cart'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    header: 'b-grey-70 lg:mb-6',
    headerContent: 'w-full',
    headerTitle: 'title-2',
    headerTotalItems: 'fw-bold flex items-center justify-end <md:text-sm',
    itemsPerShipping: 'md:mb-4',
    noItems: '-mt-4 lg:-mt-6 flex center text-center subtitle-3'
  },
  brandStyles: {
    noItems: {
      h: {
        sm: '11.5rem',
        md: '15.375rem',
        lg: '15.875rem'
      }
    }
  },
  coupon: {
    buttonVariant: 'tertiary'
  },
  item: {
    links: 'text-sm',
    actionMenu: {
      brandClasses: {
        button: 'py-3 px-0 md:py-4 gap-3',
        list: 'divide-grey-70 px-4'
      }
    }
  },
  outOfStock: {
    showRemoveAll: false,
    showSaveForLater: false
  },
  savedForLater: {
    addToCartButtonVariant: 'tertiary'
  },
  showTotalInHeader: false
} satisfies RecursivePartial<CartConfig>
